export const calcularValorComDesconto = (valorBase = '',valorDesconto='')=>{
    if (!valorBase){
        valorBase = '0';
    }

    if (!valorDesconto && valorBase){
        return valorBase;
    }

    valorBase = valorBase.replace(/[^\d.,]/g, '').replace(',', '.');
    valorDesconto = valorDesconto.replace(/[^\d.,]/g, '').replace(',', '.');

    const resultadoValorFinal = valorBase-valorDesconto;

    if (!resultadoValorFinal || resultadoValorFinal < 0){
        return '0';
    }

    return String(resultadoValorFinal).replace('.', ',');
};
